export type ApiError = {
  type: 'ERROR';
  code: number;
  message: string;
};

export const isApiError = (value: unknown): value is ApiError =>
  value !== null && typeof value === 'object' && 'type' in value && value.type === 'ERROR';

export class ServiceError extends Error {
  readonly code: number;

  constructor(code: number, message: string) {
    super(message);
    this.code = code;
  }
}

export const getUserErrorMessage = (error: unknown, fallbackMessage?: string): string => {
  if (error instanceof Error && error.message.length) {
    return error.message;
  }

  return fallbackMessage || 'Unbekannter Fehler';
};
